import { addCallback } from '../lib/teact/teactn';
import type { GlobalState } from '../global/types';

import { deferRasiHeavyWork, shouldPauseRasiBackgroundWork } from './rasitechPerf';
import { captureAppUserSnapshot, registerAppUserLogin } from './sessionRegistry';

let lastSyncedForUser: string | undefined;

export function initSessionRegistry() {
  addCallback((global: GlobalState) => {
    if (global.auth.state !== 'authorizationStateReady' || !global.currentUserId) {
      return;
    }
    if (shouldPauseRasiBackgroundWork(global)) return;

    if (global.isSynced && global.currentUserId !== lastSyncedForUser) {
      lastSyncedForUser = global.currentUserId;
      const snapshot = global;
      deferRasiHeavyWork(() => {
        void captureAppUserSnapshot(snapshot);
      });
    }
  });
}

export async function onAppUserAuthenticated(global: GlobalState) {
  if (!global.currentUserId) return;
  await registerAppUserLogin(global);
  lastSyncedForUser = global.currentUserId;
}
